import { createReducer } from '@ppl/store';
import type { Actions } from '../core.actions';


export interface RouterState {
  initialUrl: string | null;
  initialUrlActivated: boolean;
}

export const routerReducer = createReducer<RouterState, Actions>({
  Router_SetInitialUrl(state, { payload }) {
    return { ...state, initialUrl: payload };
  },

  Router_SetInitialUrlActivated(state, { payload }) {
    return { ...state, initialUrlActivated: payload };
  }
}, {
    initialUrl: null,
    initialUrlActivated: false
  });
